import {RiReactjsLine} from 'react-icons/ri'
import {FaServer} from 'react-icons/fa'
import {AiFillAppstore} from 'react-icons/ai'


const data = [
    
    {
        id: 1, icon: <RiReactjsLine/> , title: 'Frontend Development', desc: "I specialize in building interactive and responsive web applications using React and angular. I can create highly performant and user-friendly UI components that bring your ideas to life."
    },
    {
        id: 2, icon: <FaServer/>, title: 'Backend Development', desc: "I have extensive experience in backend development using Node.js with Express and also using Python with Django. I can build RESTful APIs and develop scalable and efficient server-side applications. With my knowledge of Express and Django REST framework, I can handle routing, middleware, and database integration to deliver robust and high-performance solutions."
    },
    {
        id: 3, icon: <AiFillAppstore/>, title: 'App Development', desc: 'I create cross-platform mobile applications with a focus on user experience and performance, using React-Native with Typescript.'
    },
    {
        id: 3, icon: <AiFillAppstore/>, title: 'Desktop App Development', desc: 'I specialize in developing cross-platform desktop applications that prioritize exceptional user experience and high performance. Leveraging the power of Electron.js & React.js, MongoDB and Firebase, I create cutting-edge applications that seamlessly run across multiple platforms.'
    }
]


export default data